import * as React from 'react'
import { useMemo } from 'react'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useData } from '@user/features/Activity/ActivitiyTypes/components/ActivityTypesList/hooks/useData'

export const ActivityTypeProvider: React.FC<IProviderProps> = ({ render }) => {
  const { activityTypes, loading } = useData()

  const data = useMemo(
    () =>
      activityTypes.map<IOption>((x) => ({
        label: x.name!,
        value: x.id,
      })),
    [activityTypes],
  )

  return <>{render(data ?? [], loading)}</>
}
ActivityTypeProvider.displayName = 'ActivityTypeProvider'
